import { useNavigate } from "react-router";
import { ScoreCardFragment } from "@/graphql/generated/graphql";
import { ScoreCardLocationState } from "../EvaluationNew/EvaluationNew";
import { ScrollShadowContainer } from "../ScrollShadowContainer/ScrollShadowContainer";
import { ScoreCardMenuProps } from "./ScoreCardMenu.decl";

export function ScoreCardMenu({ data, onClickItem }: ScoreCardMenuProps) {
  const navigate = useNavigate();

  const handleOnClick = (scoreCard: ScoreCardFragment) => () => {
    onClickItem(scoreCard);
    navigate("../new", {
      state: {
        scoreCardId: scoreCard.ID,
      } as ScoreCardLocationState,
    });
  };

  return (
    <ScrollShadowContainer className="mt-3 max-h-full overflow-auto rounded-md border border-border bg-background">
      <div className="flex flex-col divide-y divide-border">
        {data.map((scoreCard, index) => (
          <button
            type="button"
            key={scoreCard.ID}
            onClick={handleOnClick(scoreCard)}
            data-test={`score-card-menu-item-${index}`}
            className="flex min-h-12 w-full flex-col items-start gap-0.5 px-4 py-3 text-left first:rounded-t-md last:rounded-b-md hover:bg-accent"
          >
            <span className="text-xs font-medium">{scoreCard.name}</span>
            {Boolean(scoreCard.description) && (
              <span className="text-xs text-muted-foreground">
                {scoreCard.description}
              </span>
            )}
          </button>
        ))}
      </div>
    </ScrollShadowContainer>
  );
}
